import { render, staticRenderFns } from "./parkingAreaManageList.vue?vue&type=template&id=b7132710&scoped=true"
import script from "./parkingAreaManageList.vue?vue&type=script&lang=js"
export * from "./parkingAreaManageList.vue?vue&type=script&lang=js"
import style0 from "./parkingAreaManageList.vue?vue&type=style&index=0&id=b7132710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7132710",
  null
  
)

export default component.exports